module.exports = __webpack_public_path__ + "img/cccsf.cd14893f.png";